module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"social_media_url":{"instagram":"instagram.com","naver_cafe":"cafe.naver.com","naver_blog":"blog.naver.com","youtube":"youtube.com","facebook":"facebook.com","vimeo":"vimeo.com"},"link_to_social_media":"View original text"}}')
  delete Component.options._Ctor
}
